import React from 'react'
import { Alert, Box, CircularProgress, LinearProgress, Stack, Typography } from '@mui/material'
import type { TabularImportProgressUpdate } from '@app/src/types/tabularImport'

export type ProcessingStepProps = {
  progress: number
  realtimeProgress: TabularImportProgressUpdate | null
  totalRows?: number
  successfulRows?: number
  failedRows?: number
  errorMessage?: string | null
}

const ProcessingStep: React.FC<ProcessingStepProps> = ({
  progress,
  realtimeProgress,
  totalRows,
  successfulRows = 0,
  failedRows = 0,
  errorMessage,
}) => {
  return (
    <Stack spacing={4} alignItems="center">
      <CircularProgress size={60} />
      <Typography variant="h5">Processing data rows...</Typography>
      <Box width="100%" maxWidth={600}>
        <Typography variant="body2" color="text.secondary" gutterBottom>
          Processing your file using the approved mappings...
        </Typography>
        {(totalRows !== undefined || realtimeProgress) && (
          <>
            <LinearProgress variant="determinate" value={progress} sx={{ mt: 2, mb: 1 }} />
            <Typography variant="caption" color="text.secondary">
              {realtimeProgress
                ? `${realtimeProgress.processedRows} / ${realtimeProgress.totalRows} rows processed (${realtimeProgress.successCount} success, ${realtimeProgress.failedCount} failed)`
                : `${successfulRows + failedRows} / ${totalRows ?? 0} rows processed`}
            </Typography>
          </>
        )}
      </Box>
      {errorMessage && (
        <Alert severity="error" sx={{ maxWidth: 600 }}>
          {errorMessage}
        </Alert>
      )}
    </Stack>
  )
}

export default ProcessingStep
